import { ProgressBarProps } from './progress-bar-types'
import {
  ProgressContainer,
  ProgressBarOuter,
  ProgressBarBackground,
  ProgressBarInner,
  ProgressText,
  Subtitle,
} from './style-component'

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  maxProgress,
  minProgress = 0,
  status,
  isClaimed,
  isExChange,
}) => {
  const getProgressBarWidth = () => {
    const percent = !isExChange && !isClaimed ? 90 : 100
    return `${(progress / maxProgress) * percent}%`
  }
  const isCompleted = progress > 0 && maxProgress > 0 && progress >= maxProgress

  return (
    <>
      {(minProgress > 0 && minProgress <= 1 && !isCompleted) ?
        <Subtitle>Ver misión</Subtitle> :
        <ProgressContainer>
          <ProgressBarOuter>
            <ProgressBarBackground>
              <ProgressBarInner
                $progress={progress}
                $status={status}
                style={{ width: getProgressBarWidth() }}
              />
            </ProgressBarBackground>
            <ProgressText $status={status}>
              {(!isCompleted || status !== 'completed') ?
                <>{progress} / {maxProgress}</>
                :
                <>Completado</>
              }
            </ProgressText>
          </ProgressBarOuter>
        </ProgressContainer>
      }
    </>
  )
}

export default ProgressBar
